import type { ExpenseStatus } from './api';

export const STATUS_META: Record<ExpenseStatus, { label: string; className: string }> = {
  pending_approver: { label: 'Awaiting approval', className: 'bg-amber-100 text-amber-700' },
  rejected_by_approver: { label: 'Rejected by approver', className: 'bg-red-100 text-red-700' },
  pending_finance: { label: 'Awaiting finance', className: 'bg-blue-100 text-blue-700' },
  rejected_by_finance: { label: 'Rejected by finance', className: 'bg-red-100 text-red-700' },
  approved: { label: 'Approved — payment pending', className: 'bg-green-100 text-green-700' },
  paid: { label: 'Paid', className: 'bg-gray-200 text-gray-700' },
};
